/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_Body_2Inputs */

const en_how_we_work_build_body_2 = /** @type {(inputs: How_We_Work_Build_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We test what should happen when information is incomplete, a tool is unavailable or a request needs judgment.`)
};

const lv_how_we_work_build_body_2 = /** @type {(inputs: How_We_Work_Build_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs pārbaudām, kam jānotiek, ja informācija nav pilnīga, rīks nav pieejams vai pieprasījums prasa cilvēka spriedumu.`)
};

/**
* | output |
* | --- |
* | "We test what should happen when information is incomplete, a tool is unavailable or a request needs judgment." |
*
* @param {How_We_Work_Build_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_body_2 = /** @type {((inputs?: How_We_Work_Build_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_body_2(inputs)
	return en_how_we_work_build_body_2(inputs)
});